export default "__VITE_ASSET__BQbHn4gl__"